<template lang='pug'>
.marketDetail-container(v-if="!bookMarksLoading&&data.title")
    topContent(:bigTitle="data.title" :marketName="marketName" :img="data.bigimg" :id='data.id')
    .img-container
        img(v-src="data.bigimg")
    .content-container(v-html="data.content" )
    Icon.zi(height="0.7rem" src="子市场@3x.png" name="子市场")
    .childMarket-container
        .child(v-for="val in data2" :key="data2.marketName" @click="$router.push({name:'marketDetail2',params:{childMarketNameId:val.id,marketNameId:marketId}})")
            .text1 {{val.marketName}}
            .text2() 查看详情
</template>

<script>
import { mapState } from 'vuex'

import { getDataHierarchy, concatWithSymbol } from '@custouch/proxy-use'
import Icon from './components/icon'
import topContent from './components/topContent'
import { getCmsStr, getPath } from './levelTitle'
export default {
    name:'marketDetail',
    props:['marketId'],
    data(){
        return {
            data:{},
            data2:[],
            marketName:''
        }
    },
    created() {
        // this.$root.$emit('updateShare',{title:this.marketName+'-'+document.title})
    },
    methods:{

    },
    components:{
        topContent,Icon
    },
    computed:{
        ...mapState(['bookMarks','userInfo','memberInfo','bookMarksLoading'])
    },
    async mounted(){
        const [{ detail, dataHierarchies, id }, { path }] = await Promise.all([getDataHierarchy({dataHierarchyId: this.marketId}),getPath(this.marketId,this.$route.meta.mId)])
        this.marketName = detail.name ? detail.name : ''
        const cms = getCmsStr({mId: this.$route.meta.mId,hId: this.marketId})
        this.$root.$emit('pageview',{title:concatWithSymbol([this.$route.meta.title,path]),cms})
        this.$root.$emit('updateShare',{title:this.marketName+'-'+document.title})
        this.$root.$emit('action',{name:this.$route.name,marketName:this.marketName})
        this.data = Object.assign({},detail,{id})
        this.data2 = dataHierarchies.reduce((pre,cur)=>{
            let param = {
                id:cur.id,
                marketName:cur.name
            }
            pre.push(param)
            return pre
        },[])
    }

}
</script>

<style scoped lang='less'>
.marketDetail-container{
    .text1{
        width:70%;
        color: #219cdc;
    }
    .text2{
        color: #219cdc;
    }
    .zi{
        margin-bottom:0.7rem;
        font-weight: 700;
    }
    
    padding-left:1rem;
    padding-right: 1rem;
   .img-container{
       height:9.4rem;
       width:100%;
       margin-top:0.8rem;
       margin-bottom:0.6rem;
       img{
           display: block;
           width: 100%;
           height: 100%;
           border-radius: 0.5rem;
       }
   }
    .content-container{
        line-height: 1.1rem;
        color: #00448a;
        font-size: 0.6rem;
        margin-bottom: 1.2rem;
    }
    .childMarket-container{
        .child{
            border-radius: 0.2rem;
            padding-top:0.4rem;
            padding-bottom:0.4rem;
            padding-left:0.5rem;
            padding-right: 0.5rem;
            display: flex;
            justify-content: space-between;
            align-items: center;
            background:#f3f3f3; ;
            color: #219CDC;
            font-size: 0.6rem;
            margin-bottom:0.5rem;
        }
    }
}

</style>